






































import { Vue, Component, Prop } from 'vue-property-decorator';
import CloseButton from '@/components/Buttons/CloseButton.vue';

@Component({
    components: {
        CloseButton,
    },
})
export default class Flyout extends Vue {
    @Prop({default: true}) public withHeaderCloseButton: boolean;
    @Prop({default: ''}) public title: string;
}
